const NAVBAR_WIDTH = "167px";

export { NAVBAR_WIDTH };
